import React, { useState, useRef, useEffect } from "react";

const Select = ({
  label,
  options,
  value,
  setValue,
  className,
  Placeholder,
  name,
  errorMsg,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownWidth, setDropdownWidth] = useState(null);
  const containerRef = useRef(null);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSelectChange = (event) => {
    setValue(name, event);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      setDropdownWidth(rect.width);
    }
  }, [containerRef.current, isOpen]);

  return (
    <div className={`relative ${className}`} ref={containerRef} {...props}>
      <label className="block text-gray-700 font-bold mb-2 dark:text-slate-200">
        {label}
      </label>
      <div
        className="mt-3 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded border border-gray-100 dark:border-gray-800 cursor-pointer flex items-center justify-between"
        onClick={handleToggle}
      >
        <input
          name={name ?? ""}
          className="w-full ring-0 focus:border-none active:border-none outline-none"
          readOnly
          value={
            value
              ? options.find((option) => option.value === value)?.label ||
                `Select ${label}`
              : Placeholder || `Select ${label?.toLowerCase()}`
          }
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-4 w-4 transition-transform duration-200 ${
            isOpen ? "transform rotate-180" : ""
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>
      {isOpen && (
        <ul
          className={`absolute z-[1000] mt-1 max-h-[200px] overflow-y-auto rounded-md border border-gray-200 bg-white p-2 shadow-lg`}
          style={{
            minWidth: dropdownWidth || "auto",
          }}
        >
          {options?.length ? (
            options.map((option, index) => (
              <li
                key={index}
                onClick={() => handleSelectChange(option.value)}
                className={`flex w-full cursor-pointer justify-between truncate rounded-md px-3 py-2 hover:bg-gray-100 text-sm`}
              >
                {option.label}
              </li>
            ))
          ) : (
            <div className="p-3 text-center">No data found</div>
          )}
        </ul>
      )}
      {
        errorMsg && <div className='text-red-500 my-2' >{errorMsg}</div>
      }
    </div>
  );
};

export default Select;
